export const initialState = {
  mfaSettings: [],
  mfaEnforcementValidation: null
};
